import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "会社", -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }),
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }),
  /*#__PURE__*/_createElementVNode("th", { class: "col-6" }, "会社名"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-1" }, "利用"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-1" }, "納品")
], -1)
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_list_content_layout = _resolveComponent("list-content-layout")!
  const _component_company_update_dialog = _resolveComponent("company-update-dialog")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_list_content_layout, null, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      operation: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showingAddModal = true))
          }, "追加")
        ])
      ]),
      "table-header": _withCtx(() => [
        _hoisted_3
      ]),
      "table-body": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (c) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: c.key
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'DeliverySlipList', params: { companyKey: c.key } },
                class: "btn btn-outline-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 納品書一覧 ")
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: { name: 'User', params: { companyKey: c.key } },
                class: "btn btn-outline-success ml-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" ユーザー一覧 ")
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-warning ml-2",
                onClick: ($event: any) => (_ctx.onClickedModify(c))
              }, _hoisted_8, 8, _hoisted_6),
              _createElementVNode("button", {
                class: "btn btn-danger ml-2",
                onClick: ($event: any) => (_ctx.onClickedDelete(c))
              }, _hoisted_11, 8, _hoisted_9)
            ]),
            _createElementVNode("td", {
              textContent: _toDisplayString(c.name)
            }, null, 8, _hoisted_12),
            _createElementVNode("td", _hoisted_13, [
              (c.isAvailable)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "利用可能"))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "利用不可"))
            ]),
            _hoisted_16
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showingAddModal)
          ? (_openBlock(), _createBlock(_component_company_update_dialog, {
              key: 0,
              onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showingAddModal = false)),
              onUpdated: _ctx.onUpdated,
              "is-add": true
            }, null, 8, ["onUpdated"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.modifyModal.showing)
          ? (_openBlock(), _createBlock(_component_company_update_dialog, {
              key: 0,
              onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modifyModal.showing = false)),
              onUpdated: _ctx.onUpdated,
              "is-add": false,
              "company-key": _ctx.modifyModal.targetId
            }, null, 8, ["onUpdated", "company-key"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.deleteModal.showing)
          ? (_openBlock(), _createBlock(_component_confirm_delete_modal, {
              key: 0,
              onDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteModal.showing = false)),
              "target-obj": _ctx.deleteModal.targetObj,
              "target-name": _ctx.deleteModal.targetName,
              onShouldDelete: _ctx.deleteCompany
            }, null, 8, ["target-obj", "target-name", "onShouldDelete"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}